module.exports = {"620723101":"沙河镇","620723102":"新华镇","620723103":"蓼泉镇","620723104":"平川镇","620723105":"板桥镇","620723106":"鸭暖镇","620723107":"倪家营镇","620723500":"国营临泽农场","620723501":"五泉林场","620723502":"沙河林场","620723503":"小泉子治沙站","620723504":"园艺场","620723505":"良种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620723.json
// module id = 2921
// module chunks = 0